import { render, staticRenderFns } from "./customer-payment-behaviour.vue?vue&type=template&id=4c94dd04&scoped=true&"
import script from "./customer-payment-behaviour.vue?vue&type=script&lang=ts&"
export * from "./customer-payment-behaviour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94dd04",
  null
  
)

export default component.exports